// @auto-index

import _1r1242x2208 from './1r1242x2208.jpg'
import _1r1440x900 from './1r1440x900.jpg'
import _2r1242x2208 from './2r1242x2208.jpg'
import _2r1440x900 from './2r1440x900.jpg'
import _3r1242x2208 from './3r1242x2208.jpg'
import _3r1440x900 from './3r1440x900.jpg'
import _4r1242x2208 from './4r1242x2208.jpg'
import _4r1440x900 from './4r1440x900.jpg'
import _5r1242x2208 from './5r1242x2208.jpg'
import _5r1440x900 from './5r1440x900.jpg'
import _6r1242x2208 from './6r1242x2208.jpg'
import _6r1440x900 from './6r1440x900.jpg'

export { default as _1r1242x2208 } from './1r1242x2208.jpg'
export { default as _1r1440x900 } from './1r1440x900.jpg'
export { default as _2r1242x2208 } from './2r1242x2208.jpg'
export { default as _2r1440x900 } from './2r1440x900.jpg'
export { default as _3r1242x2208 } from './3r1242x2208.jpg'
export { default as _3r1440x900 } from './3r1440x900.jpg'
export { default as _4r1242x2208 } from './4r1242x2208.jpg'
export { default as _4r1440x900 } from './4r1440x900.jpg'
export { default as _5r1242x2208 } from './5r1242x2208.jpg'
export { default as _5r1440x900 } from './5r1440x900.jpg'
export { default as _6r1242x2208 } from './6r1242x2208.jpg'
export { default as _6r1440x900 } from './6r1440x900.jpg'

export default {
  _1r1440x900,
  _2r1440x900,
  _3r1440x900,
  _4r1440x900,
  _5r1440x900,
  _6r1440x900,
  _1r1242x2208,
  _2r1242x2208,
  _3r1242x2208,
  _4r1242x2208,
  _5r1242x2208,
  _6r1242x2208
}
